var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7557 19.0171V16.5637C9.75568 15.9397 10.2577 15.4327 10.8797 15.4285H13.1582C13.7832 15.4285 14.2899 15.9367 14.2899 16.5637V19.0247C14.2897 19.5546 14.7113 19.9876 15.2392 20H16.7582C18.2725 20 19.5 18.7685 19.5 17.2495V10.2703C19.4919 9.67266 19.2122 9.11148 18.7405 8.74643L13.5456 4.54824C12.6355 3.81725 11.3417 3.81725 10.4316 4.54824L5.25949 8.75404C4.78599 9.11762 4.50583 9.67973 4.5 10.2779V17.2495C4.5 18.7685 5.72753 20 7.24177 20H8.76076C9.30186 20 9.74051 19.5599 9.74051 19.0171",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.fd609b3b5808c73d91e08788b0b0a3a3.svg";
export { ForwardRef as ReactComponent };